import React from 'react';
import { useNotification } from '../../contexts/NotificationContext';

// ===== Composant NotificationContainer =====
const NotificationContainer: React.FC = () => {
  const { notifications, removeNotification } = useNotification();

  const getIcon = (type: string) => {
    switch (type) {
      case 'success': return 'fa-check-circle';
      case 'error': return 'fa-exclamation-circle';
      case 'warning': return 'fa-exclamation-triangle';
      default: return 'fa-info-circle';
    }
  };

  return (
    <div className="fixed top-6 right-6 z-50 space-y-4">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`notification notification-${notification.type} show`}
          onClick={() => removeNotification(notification.id)}
        >
          <div className="flex items-center gap-3">
            <i className={`fas ${getIcon(notification.type)} text-xl`}></i>
            <span className="font-medium">{notification.message}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationContainer;
